module.exports = __webpack_public_path__ + "img/base_hiver_ski_nordique.dbdae07d.svg";